import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import Api from '@/services/http'
import * as Types from './type'
import { AppDispatch } from '..'
import { ResOrderDetailType } from '@/services/api/type'

const initialState: Types.OrderState = {
  searchRecord: null,
  orderDetailInfo: null,
}

const logisticsSlice = createSlice({
  name: 'logistics',
  initialState: initialState,
  reducers: {
    setLogisticsSearchRecord(state, action) {
      return {
        ...state,
        searchRecord: action.payload,
      }
    },
    setOrderDetailInfo(state, action: PayloadAction<ResOrderDetailType>) {
      return {
        ...state,
        orderDetailInfo: action.payload,
      }
    },
  },
})

/**
 * 订单详情
 * @description 用订单列表加订单号参数找详情
 */
export const queryOrderDetailByList = async (data: Types.QueryTrace) => {
  const response = await Api.admin.post<ResOrderDetailType>('/api/order_query/list', data)
  return response?.data
}

/** 订单详情 */
export const queryOrderDetail = (data: Types.QueryTrace) => async (dispatch: AppDispatch) => {
  try {
    const response = await Api.admin.post<ResOrderDetailType>('/api/order_query/get', data)
    dispatch(logisticsSlice.actions.setOrderDetailInfo(response.data))
    // dispatch(setProgress({ progress: false }))
    return response.data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * 轨迹查询
 * @param params
 * @returns
 */
export const queryTrace = (params: Types.TraceType) => Api.admin.post<Types.ResponseQueryTraceType>('/api/order_query/trace', params)

export const { setLogisticsSearchRecord } = logisticsSlice.actions
export default logisticsSlice.reducer
